var popup = document.querySelector('.popup__window')
var overlay = document.querySelector('.popup__overlay')
var opener = document.querySelectorAll('.openmodal')
var closer = document.querySelector('.closemodal')
var body = document.querySelector('body')

function showModal () {
  body.insertBefore(overlay, body.querySelector(':first-child'))
  overlay.style.display = 'block'
  body.insertBefore(popup, body.querySelector(':first-child'))
  popup.style.display = 'block'
  window.scrollTo(0, 0)
}

function hideModal () {
  body.insertBefore(overlay, body.querySelector(':first-child'))
  overlay.style.display = 'none'
  body.insertBefore(popup, body.querySelector(':first-child'))
  popup.style.display = 'none'
}


for(var i = 0; i < opener.length; i++){
  opener[i].addEventListener('click', showModal)
}
if(overlay != null && closer != null){
  overlay.addEventListener('click', hideModal)
  closer.addEventListener('click', hideModal)
}


var anchors = document.querySelectorAll('.recyclage a[href^="#"]')
for(var i = 0; i < anchors.length; i++){
  anchors[i].addEventListener('click', function (e) {
    e.preventDefault()

    document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
    })
  })
}